import styled from 'styled-components'

export const Center = styled.div`
  margin: 0 auto;
  text-align: center;
`
